import { Dialog } from '@headlessui/react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { Modal } from '@/components/common/modal';
import { Button, ButtonVariant } from '@/components/form/button';

import { useFermentationAction } from '../../hooks/use-fermentation-action';
import { useFermentationUpdate } from '../../hooks/use-fermentation-update';

interface IProps {
  /** based on the state, modal will be rendered */
  isOpen: boolean;

  /** toggle modal open and close */
  toggle: () => void;
}

export const RemoveFermentationModal: React.FC<IProps> = ({ isOpen, toggle }) => {
  const { t } = useTranslation('translation', { useSuspense: false });
  const { state } = useFermentationAction();

  const { deleteMutation } = useFermentationUpdate({
    onSettledFn: () => toggle(),
    onErrorFn: () => toast.error(t('fermentations.delete.error')),
    onSuccessFn: () => toast.success(t('fermentations.delete.success')),
  });

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      title={t('fermentations.delete.title')}
      conatinerClassnames="w-full md:w-5/6 lg:w-2/3 xl:w-1/2 2xl:w-1/3"
    >
      <div className="flex flex-col gap-3 py-6">
        <Dialog.Description>{t('fermentations.delete.body')}</Dialog.Description>
      </div>
      <div className="flex justify-end gap-4">
        <Button
          variant={ButtonVariant.Secondary}
          onClick={() => toggle()}
          disabled={deleteMutation.isLoading}
        >
          {t('common.no')}
        </Button>
        <Button
          onClick={() => deleteMutation.mutate(state.id)}
          isLoading={deleteMutation.isLoading}
        >
          {t('common.yes')}
        </Button>
      </div>
    </Modal>
  );
};
